import {MalnutritionPhaseHelper} from './malnutrition-phase.helper';

export class MUACHelper {

    // For woman
    acuteMalnutrition = {
        color: '#E2231A',
        marker: 'acute-malnutrition',
        phase: MalnutritionPhaseHelper.ACUTE_MALNUTRITION,
        daysToNextVisit: 7,
        sachetsCount: 28,
        dailySachetsCount: 2,
        sachetsKcal: 540,
        treatmentDuration: 60,
        sachetImage: 'sachet-risk-of-acute-malnutrition.svg',
        sachetsInformation: 'Sobres para desnutrición aguda',
        instructions: [
            `<b>• Entregar:</b> 28 sobres de alimento terapéutico listo para consumir para embarazadas;`,
            `<b>• Dosis:</b> 2 sobres al día (540 kcal/día) como suplemento a su alimentación;`,
            `<b>• Seguimiento:</b> Visite a esta mujer cada dos semanas para volver a medir el MUAC y observar si hubo o no progresso;`,
            `<b>• Alimentación:</b> Continuar su alimentación normal.`,
        ], confirmation: [
            `Entregué 28x sobres;`,
            `Informé a la mujer sobre la dosis correcta de 2x sobres (540 Kcal) al día durante 2 semanas`,
        ]
    };

    severeAcuteMalnutrition = {
        color: '#E2231A',
        marker: 'severe-acute-malnutrition',
        phase: MalnutritionPhaseHelper.SEVERE_ACUTE_MALNUTRITION,
        daysToNextVisit: 7,
        sachetsCount: 14,
        dailySachetsCount: 2,
        sachetsKcal: 500,
        treatmentDuration: 75,
        sachetImage: 'sachet-severe-acute-malnutrition.svg',
        sachetsInformation: 'Sobres para desnutrición aguda severa',
        instructions: [
            `<b>• Entregar:</b> 14 sobres del alimento terapéutico listo para consumir para desnutrición aguda severa como suplemento a su alimentación;`,
            `<b>• Dosis:</b> 2 sobres al día (${500 * 2} Kcal/ día) durante una semana;`,
            `<b>• Seguimiento:</b> Visite al niño cada semana para volver a medir el MUAC y observar si hubo o no progreso;`,
            `<b>• Tratamiento:</b> La duración del tratamiento puede ser hasta 75 días;`,
            `<b>• Alimentación:</b> Continuar su alimentación normal.`
        ], confirmation: [
            'Entregué 14x sobres',
            `Informé a la familia sobre la dosis correcta de 2x sobres (1000 Kcal) al día durante 1 semana`
        ]
    };

    moderateAcuteMalnutrition = {
        color: '#F26A21',
        marker: 'moderate-acute-malnutrition',
        phase: MalnutritionPhaseHelper.MODERATE_ACUTE_MALNUTRITION,
        daysToNextVisit: 14,
        sachetsCount: 14,
        dailySachetsCount: 1,
        sachetsKcal: 500,
        treatmentDuration: 60,
        sachetImage: 'sachet-moderate-acute-malnutrition.svg',
        sachetsInformation: 'Sobres para desnutrición aguda moderada',
        instructions: [
            `<b>• Entregar: </b>14 sobres del alimento terapéutico listo para consumir para desnutrición aguda severa como suplemento a su alimentación;`,
            `<b>• Dosis: </b>1 sobres al día (${500} Kcal/ día) durante una semana;`,
            `<b>• Seguimiento:</b> Visite al niño cada dos semanas para volver a medir el MUAC y observar si hubo o no progreso;`,
            `<b>• Tratamiento:</b> La duración del tratamiento puede ser hasta 60 días;`,
            `<b>• Alimentación:</b> Continuar su alimentación normal.`
        ], confirmation: [
            'Entregué 14x sobres',
            'Informé a la familia sobre la dosis correcta de 1x sobres (500 Kcal) al dia durante 2 semanas',
        ]
    };

    riskOfAcuteMalnutrition = {
        color: '#FFC20E',
        marker: 'risk-of-acute-malnutrition',
        phase: MalnutritionPhaseHelper.RISK_OF_ACUTE_MALNUTRITION,
        daysToNextVisit: 14,
        sachetsCount: 14,
        dailySachetsCount: 1,
        sachetsKcal: 270,
        treatmentDuration: 60,
        sachetImage: 'sachet-risk-of-acute-malnutrition.svg',
        sachetsInformation: 'Sobres para riesgo de desnutrición aguda',
        instructions: [ // Instructions to child family follow in this case
            `<b>• Entregar:</b> 14 sobres de alimento terapéutico listo para consumir para riesgo de desnutrición como suplemento a su alimentación;`,
            `<b>• Dosis: </b>1 sobre al día 270 Kcal/ día)como suplemento a su alimentación;`,
            `<b>• Seguimiento:</b> Visite al niño cada dos semanas para volver a medir el MUAC y observar si hubo o no progreso;`,
            `<b>• Tratamiento:</b> La duración del tratamiento puede ser hasta 60 días;`,
            `<b>• Alimentación:</b> Continuar su alimentación normal.`
        ],
        confirmation: [
            'Entregué 14x sobres',
            'Informé a la familia sobre la dosis correcta de 1x sobre (270 Kcal) al dia durante 2 semanas',
        ]
    };

    outsideOfRiskZone = {
        color: '#80BD41',
        marker: 'outside-risk-zone',
        phase: MalnutritionPhaseHelper.OUT_OF_RISK_ZONE,
        daysToNextVisit: 30,
        sachetsCount: null,
        dailySachetsCount: null,
        sachetsKcal: null,
        treatmentDuration: null,
        sachetImage: null,
        sachetsInformation: null,
        instructions: [
            `• Continuar vigilando el estado nutricional;`,
            `• Ofrecer recomendaciones para prevenir la desnutrición.`
        ],
        confirmation: [
            'Continuar vigilando el estado nutricional;',
            'Ofrecer recomendaciones para prevenir la desnutrición.'
        ]
    };

    healed = {
        color: '#00AEEF',
        marker: 'healed',
        phase: MalnutritionPhaseHelper.HEALED_CHILD,
        daysToNextVisit: null,
        sachetsCount: null,
        dailySachetsCount: null,
        sachetsKcal: null,
        treatmentDuration: null,
        sachetImage: null,
        sachetsInformation: null,
        instructions: [
            `• Continuar vigilando el estado nutricional;`,
            `• Ofrecer recomendaciones para prevenir la desnutrición.`
        ],
        confirmation: [
            'Continuar vigilando el estado nutricional;',
            'Ofrecer recomendaciones para prevenir la desnutrición.'
        ]
    };

    getPhase(marker: string) {
        switch (marker) {
            case 'severe-acute-malnutrition':
                return this.severeAcuteMalnutrition;
            case 'acute-malnutrition':
                return this.acuteMalnutrition;
            case 'moderate-acute-malnutrition':
                return this.moderateAcuteMalnutrition;
            case 'risk-of-acute-malnutrition':
                return this.riskOfAcuteMalnutrition;
            case 'outside-risk-zone':
            case 'outsite-risk-zone': // grafia errada de versões antigas
                return this.outsideOfRiskZone;
            case 'healed':
                return this.healed;
            default:
                return null;
        }
    }

    public malnutritionPhases(): any[] {
        return [
            this.severeAcuteMalnutrition,
            this.moderateAcuteMalnutrition,
            this.riskOfAcuteMalnutrition,
            this.outsideOfRiskZone
        ];
    }
}
